export const isValidPhone = (value) => {
  const pattern =
    /^(?:\+?1[\s.-]?)?(?:\(?[2-9][0-9]{2}\)?[\s.-]?)[2-9][0-9]{2}[\s.-]?[0-9]{4}$/
  return pattern.test(value.trim())
}

export const validatePhone = (value) => {
  if (!value || isValidPhone(value)) return true

  return 'Enter a valid phone number.'
}

export const validateFax = (value) => {
  if (!value || isValidPhone(value)) return true

  return 'Enter a valid fax number.'
}

export const validatePostalCode = (value) => {
  if (!value) return true

  const regex =
    /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
  if (regex.test(value)) return true

  return 'Enter a valid postal code.'
}
